<template>
  <layout></layout>
</template>

<script>
import Vue from 'vue'
import routr from 'vue-routr'
import Layout from './views/Layout.vue'
import axios from 'axios'
const ax = axios.create({
   
  baseURL: 'http://api.classicalwof.org/restApp.php'
})

Vue.use(require('vue-cookie'))

Vue.component('layout', require('./views/Layout.vue'))
Vue.component('sprite-button', require('./components/sprite-button.vue'))
Vue.component('picker-modal', require('./components/picker-modal.vue'))

export default {
  name: 'App',
  mixins: [routr],
  data () {
    return {
      fullInductees: [],
      inductees: [],
      fountain: [],
      plaza: [],
      device: [],
      deviceAudioPaused: true,
      deviceAudioSrc: '',
      audio: new Audio()
    }
  },
  routr: {
    history: 'hash',
    routes: [
      {
        name: 'HomePage',
        path: '/',
        title: '',
      },
      {
        name: 'InducteePage',
        path: '/inductees',
        title: 'Inductees',
      },
      {
        name: 'FountainPage',
        path: '/fountain',
        playlist: 'fountain',
        title: 'Fountain',
      },
      {
        name: 'PlazaPage',
        path: '/plaza',
        playlist: 'plaza',
        title: 'Plaza',
      },
      {
        name: 'DevicePage',
        path: '/device',
        title: 'Device',
      },
      {
        name: 'InducteeDetailsPage',
        path: '/inductee/:id'
      }, {
        name: 'catchall',
        path: '*'
      }
    ]
  },
  components: {
    Layout
  },
  created () {
    this.fetchInductees()
    this.fetchFountain()
    this.fetchPlaza()
  },
  methods: {
    nowPlaying (array) {
      if (this[array].length > 0) {
        return this[array][0]
      } else {
        return {
          InducteeName: '',
          MusicTitle: '',
          ImageURL: '',
          WebMusicFile: '',
        }
      }
    },
    fetchInductees () {
      ax.get('/inductees/music')
      .then(result => {
        let inductees = result.data
        // Sort by last name.
        inductees.sort((a, b) => a.InducteeName.localeCompare(b.InducteeName))
        // Replace the inductees array in a way that makes Vue happy
        this.inductees.splice(0, this.inductees.length, ...inductees)
      })
      .catch(err => {
        console.log(err)
      })
    },
    fetchFountain () {
      ax.get('/fountain')
      .then(result => {
        // Replace the inductees array in a way that makes Vue happy
        this.fountain.splice(0, this.fountain.length, ...result.data)
      })
      .catch(err => {
        console.log(err)
      })
    },
    fetchPlaza () {
      ax.get('/plaza')
      .then(result => {
        // Replace the inductees array in a way that makes Vue happy
        this.plaza.splice(0, this.plaza.length, ...result.data)
      })
      .catch(err => {
        console.log(err)
      })
    },
    fetchFullInductee (id) {
      ax.get('/full-inductees/' + id)
      .then(result => {
        // Replace the inductees array in a way that makes Vue happy
        Vue.set(this.fullInductees, id, result.data[0])
      })
      .catch(err => {
        console.log(err)
      })
    },
    queue ({playlist, inductee}) {
      switch(playlist)
      {
          case 'device':
            this.playOnDevice(inductee)
          break
          case 'plaza':
            ax.post('/plaza',JSON.stringify({ InducteeID: inductee.InducteeID }),
                   {
                   headers: {"Content-Type": "application/x-www-form-urlencoded"}
                   }).then(this.fetchPlaza.bind(this));
          break
          case 'fountain':
            ax.post('/fountain',JSON.stringify({ InducteeID: inductee.InducteeID }),
                   {
                   headers: {"Content-Type": "application/x-www-form-urlencoded"}
                 }).then(this.fetchFountain.bind(this));
          break
        }
    },
    bump ({playlist, inductee}) {
      switch(playlist)
      {
          case 'device':
            this.playOnDevice(inductee)
          break
          case 'plaza':
            fetch('http://api.classicalwof.org/restApp.php/plaza/' + inductee.PlazaPlaylistID, {
              method: 'post',
              mode: 'no-cors',
              headers: {
                'X-Http-Method-Override': 'PUT'
              },
              body: new FormData(document.getElementById('post-form'))
            }).then(this.fetchPlaza.bind(this))
          break
          case 'fountain':
            fetch('http://api.classicalwof.org/restApp.php/fountain/' + inductee.FountainPlaylistID, {
              method: 'post',
              mode: 'no-cors',
              headers: {
                'X-Http-Method-Override': 'PUT'
              },
              body: new FormData(document.getElementById('post-form'))
            }).then(this.fetchFountain.bind(this))
          break
        }
    },
    playOnDevice (inductee) {
      this.deviceAudioPaused = false
      this.deviceAudioSrc = 'http://api.classicalwof.org/media/MediaSmall/' + inductee.WebMusicFile
      this.audio.src = this.deviceAudioSrc
      this.audio.play()
      // A relic of the playlist thing
      this.device.splice(0, this.device.length, inductee)
    },
    playRadioTour (inductee) {
      this.deviceAudioPaused = false
      this.deviceAudioSrc = inductee.RadioTour
      this.audio.src = this.deviceAudioSrc
      this.audio.play()
      // A relic of the playlist thing
      this.device.splice(0, this.device.length, inductee)
    },
    togglePauseOnDevice () {
      this.deviceAudioPaused = ! this.deviceAudioPaused
      if (this.deviceAudioPaused) {
        this.audio.pause()
      } else {
        this.audio.play()
      }
    },
    stopOnDevice () {
      this.deviceAudioSrc = ''
      this.deviceAudioPaused = true
      this.audio.src = this.deviceAudioSrc
    }
  }
}
</script>
